<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Cadastro de Solicitante</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>


    <div mat-dialog-content class="p-12 pb-0 m-0">

        <form [formGroup]="professionalForm" class="w-100-p">

            <div formGroupName="person" fxLayout="row" class="w-100-p">

                <div fxLayout="column" class="w-100-p">

                    <div fxLayout="row" class="w-100-p">
                        <mat-form-field appearance="outline" class="w-100-p mr-12">
                            <mat-label>Nome</mat-label>
                            <input matInput cwgAutoFocusDirective maxlength="250" name="name" formControlName="name"
                                autofocus="true" required>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100-p mr-12">
                            <mat-label>CPF</mat-label>
                            <input matInput maxlength="14" name="cpf" formControlName="cpf" mask='000.000.000-00'>
                        </mat-form-field>


                    </div>
                </div>
            </div>

            <div fxLayout="row" class="w-100-p">
                <mat-form-field appearance="outline" class="mr-12" style="width: 33%;">
                    <mat-label>Conselho</mat-label>
                    <mat-select [compareWith]="compareSelect" name="council" formControlName="council" required>
                        <mat-option [value]="null">
                            Selecione
                        </mat-option>
                        <mat-option *ngFor="let council of councilList" [value]="council">
                            {{council.initials}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="  mr-12" style="width: 34%;">
                    <mat-label>Número</mat-label>
                    <input matInput maxlength="10" name="councilNumber" formControlName="councilNumber" required>
                </mat-form-field>


                <mat-form-field appearance="outline" class="mr-12" style="width: 33%;">
                    <mat-label>UF</mat-label>
                    <mat-select [compareWith]="compareSelect" name="state" formControlName="state" required>
                        <mat-option [value]="null">
                            Selecione
                        </mat-option>
                        <mat-option *ngFor="let state of stateList" [value]="state">
                            {{state.initials}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" class="w-100-p">
                <mat-form-field appearance="outline" class="w-45-p mr-12">
                    <mat-label>Especialidade</mat-label>
                    <input matInput type="search" autocomplete="off" [matAutocomplete]="auto"
                        formControlName="speciality" placeholder="Nome">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)='setSpeciality($event.option.value)'>
                        <mat-option *ngFor="let speciality of filteredSpecialityList" [value]="speciality">
                            {{speciality.name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-60-p">
                    <mat-label>CBO</mat-label>
                    <input matInput type="search" autocomplete="off" [matAutocomplete]="auto" [value]="cbo? cbo: null"
                        placeholder="CBO" style="color: black;" disabled=true>
                </mat-form-field>
            </div>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Empresa</mat-label>
                <input type="text" matInput formControlName="firm" [matAutocomplete]="autoFirm">
                <button matSuffix mat-icon-button aria-label="Clear" title="Cadastro de Solicitante"
                    (click)="registrationFirm()">
                    <mat-icon>add</mat-icon>
                </button>
                <mat-autocomplete #autoFirm="matAutocomplete" [displayWith]="displayFirmFn">
                    <mat-option [value]="null">

                    </mat-option>
                    <mat-option *ngFor="let firm of firmList" [value]="firm">
                        {{firm.name}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </form>
    </div>

    <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutAlign="end end">
        <button mat-raised-button (click)="dimiss()" class="mr-12">
            Cancelar
        </button>
        <button mat-raised-button (click)="confirm()" color="accent">
            Confirmar
        </button>
    </div>
</div>